import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-detalle-totem-direccion',
  templateUrl: './detalle-totem-direccion.component.html',
  styleUrls: ['./detalle-totem-direccion.component.css']
})
export class DetalleTotemDireccionComponent implements OnInit {
  @Input('detalle') detalleTotem
  public direcciones
  public infoDetalle
  public detalleConjunto = false

  constructor() { }

  ngOnInit(): void {

    console.log(this.detalleTotem)
    this.infoDetalle = this.detalleTotem
    this.direcciones = [...this.detalleTotem.info.portalData.Propiedad_Direccion]

  }


}
